<div class="product-footer">
    <ng-container *ngFor="let item of footerItems; let i = index">
        <a
                class="footer-button"
                [routerLink]="item.link"
                title="Перейти в раздел"
                (click)="(!isLogged && i === footerItems.length - 1) && handleLoginClick($event); item.label === 'Каталог' && handleCatalogClick($event)"
        >
            <nb-icon
                    [icon]="item.icon"
                    [status]="isRouteActive(item.link) ? 'primary' : 'basic'"
                    class="footer-icon">
            </nb-icon>
            <span class="cart-badge" *ngIf="item.label === 'Корзина' && (amount$ | async) > 0">
                    {{ amount$ | async }}
            </span>
            <span class="footer-name"
                  [class.active]="isRouteActive(item.link)">{{ item.label }}</span>
        </a>

        <div class="footer-divider" *ngIf="i < footerItems.length - 1"></div>
    </ng-container>
</div>
